export const getAOAServiceDetailsFormFields = (t, data = {}) => [
  {
    row: [
      {
        label: t("service_tab_createdBy") || "Created By",
        value: data.createdBy,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_creationDate") || "Creation Date",
        value: data.creationDate,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_yearEndDate") || "Year-End Date",
        value: data.yearEndDate,
        gridClass: "col-md-3",
      },
      {
        label:
          t("service_tab_natureOfEngagement") || "Nature of Engagement",
        value: data.natureOfEngagement,
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label: t("service_tab_allocationDate") || "Allocation Date",
        value: data.allocationDate,
        gridClass: "col-md-3",
      },
      {
        label:
          t("service_tab_accessReceivedDate") || "Access Received Date",
        value: data.accessReceivedDate,
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label:
          t("service_tab_actualDeliveryDate") || "Actual Delivery Date",
        value: data.actualDeliveryDate,
        gridClass: "col-md-3",
      },
      {
        label:
          t("service_tab_expectedCompletionDate") ||
          "Expected Completion Date",
        value: data.expectedCompletionDate,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_revisedStartDate") || "Revised Start Date",
        value: data.revisedStartDate,
        name: "revisedStartDate",
        type: "date",
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_revisedEndDate") || "Revised End Date",
        value: data.revisedEndDate,
        name: "revisedEndDate",
        type: "date",
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label: t("service_tab_engagementManager") || "Engagement Manager",
        value: data.engagementManager,
        tooltip: data.engagementManagerEmail,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_engagementDelegates") || "Engagement Delegates",
        value: data.engagementDelegates,
        type: "delegates",
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_teamMembers") || "Team Members",
        value: data.teamMembers,
        gridClass: "col-md-3",
      },
    ],
  },
];
